// extracted by mini-css-extract-plugin
export var actions = "_2l-0";
export var actionsContainer = "_2l-7";
export var border = "_2l-1";
export var childFullHeight = "_2l-f";
export var collapse = "_2l-2";
export var content = "_2l-a";
export var contentChild = "_2l-e";
export var fullscreen = "_2l-c";
export var hasLeftRadius = "_2l-k";
export var headerContainer = "_2l-3";
export var headerRow = "_2l-5";
export var hidePadding = "_2l-b";
export var navCollapsedGap = "_2l-l";
export var noScrollX = "_2l-m";
export var noScrollY = "_2l-n";
export var noTopPadding = "_2l-i";
export var optOutTopPadding = "_2l-d";
export var pageMain = "_2l-j";
export var pageOuter = "_2l-g";
export var pagePadding = "_2l-8";
export var pageScroll = "_2l-9";
export var profile = "_2l-o";
export var profileContainer = "_2l-p";
export var profileImage = "_2l-q";
export var profileMain = "_2l-r";
export var profileSubtitle = "_2l-t";
export var profileTitle = "_2l-s";
export var showLeftPadding = "_2l-h";
export var tabsPortalSlot = "_2l-6";
export var tabsWrapper = "_2l-4";
export var title = "_2l-u";